
import Plant from '../assets/projects/plantpage.png'
import Book from '../assets/projects/bookpage.png'
import Nasa from '../assets/projects/nasa.png'
import CodewarPage from '../assets/projects/mernCodewars.png'

export const projectMernData=[
    {
        id:1,
        name:"ToDo App",
        image:CodewarPage,
        github:"https://github.com/AnilBASARAN/mernstack-product-tracker",
        live:"https://p-tracker-v2.onrender.com",
    },
    {
        id:2,
        name:"Nasa image api",
        image:Nasa,
        github:"https://github.com/AnilBASARAN/Nasa-imagery-last",
        live:"https://anilbasaran.github.io/nasa-image-api/",
    },
    {
        id:3,
        name:"Plant Sale Page",
        image:Plant,
        github:"https://github.com/AnilBASARAN/capstone",
        live:"https://plantsforsale.netlify.app",
    },
    {
        id:4,
        name:"Book Sale Page",
        image:Book,
        github:"https://github.com/AnilBASARAN/fullstackbookproject",
        live:"https://bookstore-lac-iota.vercel.app",
    },


]